import script from "./CheckinsAutomationsLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./CheckinsAutomationsLayout.vue?vue&type=script&setup=true&lang=js"

import "./CheckinsAutomationsLayout.vue?vue&type=style&index=0&id=34ebaa6d&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34ebaa6d"]])

export default __exports__